"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const dashboard_widget_styles_1 = require("./dashboard-widget.styles");
const DashboardWidgetItem = ({ label, children }) => (react_1.default.createElement(dashboard_widget_styles_1.StyledDashboardWidgetItemWrapper, null, react_1.default.createElement(dashboard_widget_styles_1.StyledDashboardWidgetItemLabel, { transform: "uppercase" }, label), react_1.default.createElement(dashboard_widget_styles_1.StyledDashboardWidgetItemValue, null, children)));
exports.default = DashboardWidgetItem;
